import { type App, type Component } from 'vue'

// Auto-register all components in components/base-components
export const autoregisterBaseComponents = (app: App): void => {
  Object.entries(import.meta.glob('../components/BaseComponents/*.vue', { eager: true }))
    .map(([path, component]): [string, unknown] => [
      'v-' + (path.split('/').pop() as string).replace(/\.\w+$/, ''),
      component
    ])
    .forEach(([name, definition]) => {
      // Register component on this Vue instance
      if (definition && Object.prototype.hasOwnProperty.call(definition, 'default')) {
        const newObj: Component = definition
        app.component(name, newObj.default)
      }
    })
}



